import script from "./CountdownTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountdownTimer.vue?vue&type=script&setup=true&lang=ts"

import "./CountdownTimer.vue?vue&type=style&index=0&id=6b90bcbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b90bcbd"]])

export default __exports__